import { eppExpLanguageDef } from './epp-exp/epp-exp.language'

/** monaco å è½½å®æåå¤éç¥ */
let resolveMonacoLoadPromise
export const monacoLoadPromise = new Promise((resolve) => {
  resolveMonacoLoadPromise = resolve
})

export const LANG_EPP_EXP = 'eppExp'

/** å è½½å®æå */
export function handleMonacoLoad () {
  // epp exp
  monaco.languages.register({ id: LANG_EPP_EXP })
  monaco.languages.setMonarchTokensProvider(LANG_EPP_EXP, eppExpLanguageDef)
  registerSysVarsCompletion(LANG_EPP_EXP)

  initTheme()
  resolveMonacoLoadPromise()
}

export const sysVars = [{
  name: 'username',
  doc: 'å½åç¨æ·åï¼å­ç¬¦ä¸²'
}, {
  name: 'username2',
  doc: 'æ¹æ³å¤§å¹åº¦åå¯¹æ³å¤§å¹åº¦åå¯¹æ³ççæ¹å¼åå¯¹åå¯¹ç¯å¾ä¸æ¹æ³ç'
}, {
  name: 'pp',
  doc: 'å¤§èæå®æå®å¤§å¤§å®æå®å¤§èæ'
}, {
  name: 'time',
  doc: 'å½èå¾·è¨èå¾·è¨å'
}]

/** ç³»ç»åéèªå¨è¡¥å¨æ³¨å */
export function registerSysVarsCompletion (langId: string) {
  monaco.languages.registerCompletionItemProvider(langId, {
    provideCompletionItems () {
      return {
        suggestions: [
          {
            label: 'sys',
            kind: monaco.languages.CompletionItemKind.Class,
            documentation: 'ç³»ç»åé',
            insertText: 'sys',
            range: null
          }
        ]
      }
    }
  })
  monaco.languages.registerCompletionItemProvider(langId, {
    provideCompletionItems (model, position) {
      return {
        suggestions: sysVars.map(sysVar => {
          return {
            label: sysVar.name,
            kind: monaco.languages.CompletionItemKind.Field,
            insertText: sysVar.name,
            range: null,
            detail: '(ç³»ç»åé) username: string',
            documentation: sysVar.doc
          }
        })
      }
    },
    triggerCharacters: ['.'] // è§¦åæç¤ºçå­ç¬¦ï¼å¯ä»¥åå¤ä¸ª
  })
}

function initTheme () {
  monaco.editor.defineTheme('eppTheme', {
    base: 'vs-dark',
    inherit: true,
    rules: [
      { token: 'epp-default', foreground: 'ffc107' },
      { token: 'epp-brackets', foreground: '78dce8' },
      { token: 'epp-number-operator', foreground: 'a9dc76' },
      { token: 'epp-logic-operator', foreground: 'ff0081' },
      { token: 'epp-sys-var', foreground: 'F59BAC', fontStyle: 'bold' },
      { token: 'epp-function', foreground: '607d8b' },
      { token: 'epp-number', foreground: '#ff6188' },
    ],
    colors: {
      'editor.foreground': '#F9FFEE',
      'editor.background': '#1a1d24',
      'editorCursor.foreground': '#ffffff',
      'editor.lineHighlightBackground': '#ffffff15',
      'editorLineNumber.foreground': '#008800',
      'editor.selectionBackground': '#ffffff21',
      'editor.inactiveSelectionBackground': '#ffffff41'
    }
  })
}
